import React, { useState, Fragment } from "react";
import { Modal, InputGroup, FormControl, Form } from "react-bootstrap";


function EditDataModal(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [description, setDescription] = useState("");
    const [tags, setTags] = useState("");
    const [seriesCount, setSeriesCount] = useState(0);
    const [deadline, setDeadline] = useState("");
    const [blocked, setBlocked] = useState(false);
    const [details, setDetails] = useState("");


    const handleShowDialog = () => {
        setDescription(props.task.description);
        setTags(props.task.tags);
        setSeriesCount(props.task.seriesCount);
        setDeadline(props.task.deadline);
        setBlocked(props.task.blocked==null?false:props.task.blocked);
        setDetails(props.task.details);
        setIsOpen(!isOpen);
    };
    const handleChangeBlocked = (event) => {
        setBlocked(event.target.checked);
    }

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleChangeDescription = (event) => {
        setDescription(event.target.value);
    }

    const handleChangeTags = (event) => {
        setTags(event.target.value);
    }

    const handleChangeSeriesCount = (event) => {
        setSeriesCount(event.target.value);
    }

    const handleChangeDeadline = (event) => {
        setDeadline(event.target.value);
    }

    const handleChangeDetails = (event) => {
        setDetails(event.target.value);
    }

    const editTaskToStackFromHere = () => {
        if (description.length === 0) {
            return;
        }
        props.editTaskToStack({
            taskId: props.task.taskId,
            description: description,
            tags: tags,
            seriesCount: seriesCount,
            deadline: deadline,
            blocked: blocked, 
            details: details
        });
        handleClose();
    }


    return <Fragment>
        <button data-cy="edit-task-btn" type="button" className="btn btn-primary" onClick={handleShowDialog}>...</button>
        <Modal animation={false} show={isOpen} onHide={handleClose} data-cy="add-data-modal" id="addData" tabIndex="-1">
            <Modal.Header closeButton>
                <Modal.Title>Edit task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <InputGroup className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="descript">Description</InputGroup.Text>
                        </InputGroup>
                        <FormControl data-cy="description-text"
                            required
                            placeholder="Description"
                            aria-label="Description"
                            aria-describedby="descript" value={description} onChange={handleChangeDescription}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="details">Details</InputGroup.Text>
                        </InputGroup>
                        <Form.Control as="textarea" data-cy="details" rows={4}
                            type="textarea"
                            placeholder="details"
                            aria-label="details"
                            aria-describedby="details" value={details} onChange={handleChangeDetails}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="blocked">Blocked</InputGroup.Text>
                        </InputGroup>
                        <FormControl data-cy="blocked-checkbox"
                            type="checkbox"
                            placeholder="Blocked"
                            aria-label="blocked"
                            aria-describedby="blocked" checked={blocked} onChange={handleChangeBlocked}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="tags">Tags</InputGroup.Text>
                        </InputGroup>
                        <FormControl
                            placeholder="Tags"
                            aria-label="Tags"
                            aria-describedby="tags"
                            value={tags}
                            onChange={handleChangeTags}
                        />
                    </InputGroup>

                    <InputGroup className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="seriesLeft">Serie Count left</InputGroup.Text>
                        </InputGroup>
                        <FormControl
                            data-cy="seriesLeft" 
                            type="number"
                            placeholder="seriesLeft"
                            aria-label="seriesLeft"
                            aria-describedby="seriesLeft"
                            value={seriesCount} onChange={handleChangeSeriesCount}
                        />
                    </InputGroup>
                    <InputGroup className="mb-3">
                        <InputGroup>
                            <InputGroup.Text id="Deadline">Deadline</InputGroup.Text>
                        </InputGroup>
                        <FormControl
                            type="date"
                            placeholder="Deadline"
                            aria-label="Deadline"
                            aria-describedby="Deadline"
                            value={deadline}
                            onChange={handleChangeDeadline}
                        />
                    </InputGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <input type="button" className="btn btn-success" data-cy="add-task-btn" onClick={editTaskToStackFromHere} value="Update task" />
                <button type="button" className="btn btn-secondary" data-cy="close-add-task-btn" onClick={handleShowDialog}>Close</button>
            </Modal.Footer>
        </Modal>
    </Fragment>;
}

export { EditDataModal };